var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-benifits",
      attrs: { id: "app_benifits", name: "app_benifits" }
    },
    [
      _c("h3", { staticClass: "bf-title" }, [
        _vm._v(_vm._s(_vm.appBenifit.title))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "bf-subtitle" }, [
        _vm._v(_vm._s(_vm.appBenifit.subTitle))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bf-detail" }, [
        _c(
          "ul",
          { staticClass: "bf-detail-list dp-f" },
          _vm._l(_vm.appBenifit.list, function(item) {
            return _c(
              "li",
              {
                key: item.title,
                staticClass: "block",
                style: "background-image: url('" + item.icon + "')"
              },
              [
                _c("div", { staticClass: "title icon-search" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "compare" }, [
                  _vm._v(_vm._s(item.before))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "compare" }, [
                  _vm._v(_vm._s(item.after || ""))
                ])
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }